/** Demo Follow Up Boss values for the no-sign-in and dev screens. */
export const DEMO_LEAD_SOURCES = [
   { leadSource: 'Zillow', totalLeads: 84, historicalTotalLeads: 1240 },
   { leadSource: 'Realtor.com', totalLeads: 51, historicalTotalLeads: 620 },
   { leadSource: 'Website', totalLeads: 23, historicalTotalLeads: 310 },
]
export const DEMO_PONDS = [
   { pondId: 1, pondName: 'Buyer Pond', pondLeaderId: 1, totalMembers: 312 },
]
export const DEMO_STAGES = [
   'New Lead',
   'Attempted Contact',
   'Nurture',
   'Hot Prospect',
   'Appointment Set',
   'Appointment Missed',
   'Active Client',
   'Under Contract',
   'Closed',
   'Trash',
   'Sphere',
].map((name, i) => ({
   id: String(i + 1),
   name,
   description: '',
   type: 'stage',
}))
export const DEMO_TAGS = [
   'zillow',
   'buyer',
   'seller',
   'investor',
   'do-not-call',
   'sold',
   'has-agent',
   'relocation',
].map((name) => ({ id: name, name, description: '', type: 'tag' }))
